import {
  ObjectsTableColumn,
  ObjectsTableColumnId,
  OBJECTS_PROTECTED_COLUMN_IDS
} from "app/data/constants/objectsConstants";

export const mergeHiddenColumnIds = (
  storedHiddenIds: string[] | null | undefined,
  columnIds: ObjectsTableColumnId[],
  protectedIds: ObjectsTableColumnId[] = OBJECTS_PROTECTED_COLUMN_IDS
): ObjectsTableColumnId[] => {
  const protectedSet = new Set(protectedIds);
  const validIds = new Set(columnIds);
  const stored = Array.isArray(storedHiddenIds) ? storedHiddenIds : [];

  return stored.filter(
    (id): id is ObjectsTableColumnId =>
      validIds.has(id as ObjectsTableColumnId) &&
      !protectedSet.has(id as ObjectsTableColumnId)
  );
};

export const getVisibleObjectColumns = (
  columns: ObjectsTableColumn[],
  hiddenIds: ObjectsTableColumnId[]
): ObjectsTableColumn[] => {
  const hidden = new Set(hiddenIds);
  return columns.filter((column) => !hidden.has(column.id));
};

export const readHiddenColumnIdsFromSession = (
  storageKey: string
): string[] | null => {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const writeHiddenColumnIdsToSession = (
  storageKey: string,
  hiddenIds: ObjectsTableColumnId[]
): void => {
  sessionStorage.setItem(storageKey, JSON.stringify(hiddenIds));
};
